"use client";

import type { FC, Ref } from "react";
import { Flex, useThemeSlot } from "@huub-web/ui";
import type { ThemeScope } from "@huub-web/ui/contexts/ThemeSlotContext";

import { DefaultPageHeading } from "../../components/DefaultPageHeading/DefaultPageHeading";

export type DocumentsHeadingTemplateProps = {
  scope?: ThemeScope;
  title?: string;
  description?: string;
  ref?: Ref<HTMLDivElement>;
};

export const DocumentsHeadingTemplate: FC<DocumentsHeadingTemplateProps> = ({
  scope = "documentsOutgoing",
  title,
  description,
  ref,
}) => {
  const PageHeading = useThemeSlot({
    key: "pageHeading",
    defaultComponent: DefaultPageHeading,
  });

  return (
    <Flex ref={ref} direction="column" gap="s">
      <PageHeading scope={scope} title={title} description={description} />
    </Flex>
  );
};
